import React from 'react';

interface EventImageCreditProps {
  artistCredit?: string | null;
  modelCredit?: string | null;
  className?: string;
}

function cleanCredit(value?: string | null) {
  const trimmed = value?.trim();
  return trimmed || null;
}

export function EventImageCredit({
  artistCredit,
  modelCredit,
  className = '',
}: EventImageCreditProps) {
  const artistName = cleanCredit(artistCredit);
  const modelName = cleanCredit(modelCredit);

  if (!artistName && !modelName) return null;

  return (
    <figure className={['hero-credit', 'event-image-credit', className].filter(Boolean).join(' ')} aria-label="Event image credits">
      <div className="hc-people">
        {artistName && (
          <div>
            <span className="role">Artist</span>
            <strong>{artistName}</strong>
          </div>
        )}
        {modelName && (
          <div>
            <span className="role">Model</span>
            <strong>{modelName}</strong>
          </div>
        )}
      </div>
    </figure>
  );
}
